import api from './APIService';

class VehicleService {
	getAll(userId) {
		return api.fetch({ method: 'get', path: '/participant/vehicle/' + userId })
	}
	getByUsers(data) {
		return api.fetch({ method: 'post', path: '/participant/vehicle/getByUsers', data })
	}
	getTypesVehicle() {
		return api.fetch({ method: 'get', path: '/participant/vehicle/types' })
	}
	getVehicleUser($userId, $id) {
		return api.fetch({ method: 'get', path: '/participant/vehicle/' + $userId + '/' + $id })
	}
	create(data) {
		return api.fetch({ method: 'post', path: '/participant/vehicle/', data })
	}
	update(data) {
		return api.fetch({ method: 'put', path: '/participant/vehicle/', data })
	}
	delete($userId, $id) {
		return api.fetch({ method: 'delete', path: '/participant/vehicle/' + $userId + '/' + $id })
	}
	getBrandsByType($vehicleTypeId) {
		return api.fetch({ method: 'get', path: '/participant/vehicle/types/' + $vehicleTypeId })
	}
	getMultipleVehicle(data) {
		return api.fetch({ method: 'post', path: '/participant/vehicle/getMultipleVehicle', data })
	}
	getVehiclesUsers(data) {
		return api.fetch({ method: 'post', path: '/participant/vehicle/getVehiclesUsers', data })
	}
}

export default new VehicleService();
